import { createContext } from 'react';
import { ServiceContextState } from './servicesContext.state';
export const ServicesContext = createContext<Partial<ServiceContextState> | undefined>(undefined);